var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.okLoad)?_c('div',{staticClass:"Group-product-details"},[_c('div',{staticClass:"product-details"},[_c('product-details',{attrs:{"artworks":_vm.artworks,"mockups":_vm.mockups,"originProduct":_vm.originProduct,"personalized":_vm.personalized,"platform":_vm.platform,"variants":_vm.variants,"permalink":_vm.permalink}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f36f66e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BundledProduct/Product.vue
// module id = 331
// module chunks = 0